import { atom } from "jotai"
import { GetRequestCached2 } from "../api"
import { GetRequest } from "../api"
import { urls } from "../constants"

export const ExpenseHeadDetailsData = atom([])
export const fetchExpenseHeadDetails = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getExpenseHeadDetails + '?', data)
    if (res.status === 'Success') {
      set(ExpenseHeadDetailsData, res.Data.Table)
    }
  } catch (error) {
    console.error('Error fetching Expense Heade:', error)
    set(ExpenseHeadDetailsData, [])
  }
})
export const ExpenseSubHeadDetailsData = atom([])
export const fetchExpenseSubHeadDetails = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getExpenseSubHeadDetails + '?', data)
    if (res.status === 'Success') {
      set(ExpenseSubHeadDetailsData, res.Data.Table)
    }
  } catch (error) {
    console.error('Error fetching Expense Sub Heade:', error)
    set(ExpenseSubHeadDetailsData, [])
  }
})
